import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import useApiManager from '../../utils/Api/apiManager';

const AccountsAutoComplete = ({ setAccountId, accountId, shouldFetchSingleAccount, required = false, small = false, fullWidth = true }) => {
    const [accountOptions, setAccountOptions] = useState([]);
    const [selectedOption, setSelectedOption] = useState(null);
    const [loading, setLoading] = useState(false);
    const [pageNumber, setPageNumber] = useState(1);
    const [totalCount, setTotalCount] = useState(0);
    const [inputValue, setInputValue] = useState('');
    const pageSize = 6;
    const { post, get } = useApiManager();

    const fetchAndSetData = async (pageNum, inputText) => {
        try {
            setLoading(true);

            const payload = {
                pageNumber: pageNum,
                pageSize,
                filters: [
                    {
                        fieldName: 'accountName', // Filter field
                        filterOperator: 2, // Example: "contains" operator
                        fieldValue: inputText || '', // Use inputValue for filtering
                        fieldType: 1, // Example: string field type
                    },
                ],
                sortField: '', // Optional: Add sort field if needed
                sortDescending: false, // Optional: Set sorting direction
            };

            const response = await post('/accounts/paged', payload);

            const options = response.items.map(account => ({
                label: account.accountName,
                value: account.id,
            }));

            setAccountOptions(prev =>
                pageNum === 1 ? options : [...prev, ...options] // Reset or append options based on page
            );
            setTotalCount(response.totalCount);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false);
        }
    };

    // Fetch data when the component mounts or input value changes
    useEffect(() => {
        // if (shouldFetchSingleAccount === true ) {
        //     return;
        // }
        if (inputValue.length >= 2) {
            fetchAndSetData(1, inputValue); // Fetch with updated input value
        } else if (inputValue === '') {
            fetchAndSetData(1, ''); // Clear filter when input is cleared
        }
    }, [inputValue]);

    useEffect(() => {
        if (accountId > 0 && shouldFetchSingleAccount) {
           
            const fetchAccountById = async () => {
                try {
                    setLoading(true);
                    const response = await get(`/accounts/${accountId}`);
                    const accountOption = {
                        label: response.accountName,
                        value: response.id,
                    };

                    // Add the fetched contact to options
                    setAccountOptions((prev) => {
                        // Check if the contact already exists in the options
                        const accountExists = prev.some(option => option.value === accountOption.value);

                        // If it doesn't exist, add it; otherwise, return the current options
                        if (!accountExists) {
                            return [accountOption, ...prev];
                        }
                        return prev;
                    });


                    // Set the selected option
                    setSelectedOption(accountOption);
                } catch (error) {
                    console.error('Error fetching account by ID:', error);
                } finally {
                    setLoading(false);
                }
            };

            fetchAccountById();
        }
    }, [accountId, shouldFetchSingleAccount]);

    const handleInputChange = (newValue) => {
        setInputValue(newValue);
        setPageNumber(1);
    };

    const handleScrollToBottom = () => {
        const totalFetched = accountOptions.length;
        if (totalFetched < totalCount && !loading) {
            const nextPage = pageNumber + 1;
            setPageNumber(nextPage);
            fetchAndSetData(nextPage, inputValue);
        }
    };

    const customStyles = {
        control: (provided) => ({
            ...provided,
            minHeight: small ? '40px' : '56px',
            height: small ? '40px' : '56px',
            padding: '0px 8px',
            borderRadius: '4px',
        }),
        menu: (provided) => ({
            ...provided,
            zIndex: 10,
            backgroundColor: '#fff',
            borderRadius: '4px',
        }),
    };

    return (
        <div style={{ width: fullWidth ? '100%' : 'auto' }}>
            <Select
                isLoading={loading}
                isClearable
                options={accountOptions}
                value={selectedOption} // Use the explicitly managed selected option
                onChange={(selectedOption) => {
                    setAccountId(selectedOption ? selectedOption.value : null);
                    setSelectedOption(selectedOption); // Update the selected option
                }}
                onInputChange={handleInputChange}
                placeholder="Select Account"
                styles={customStyles}
                maxMenuHeight={200}
                required={required}
                onMenuScrollToBottom={handleScrollToBottom} // Load more data on scroll
                noOptionsMessage={() => (loading ? 'Loading...' : 'No options available')}
            />
        </div>
    );
};
export default AccountsAutoComplete;